export default {"src":"/fly/_next/static/media/us.abf88f30.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};